import React from 'react';
import ReactDOM from 'react-dom';
const ConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmText = "Confirm",
  cancelText = "Cancel",
  isNotification = false, // If true, only shows an "OK" button
  overlayClassName = "", // Lets stacked callers raise the overlay above their own modal
  onCancel,
}) => {
  if (!isOpen) {
    return null;
  }

  const isDelete = confirmText === "Delete";
  const isPrimary = isNotification || !isDelete;

  const handleConfirmClick = () => {
    if (typeof onConfirm === "function") {
      onConfirm();
    }
    // For notification-style modals, always close on OK
    if (isNotification && typeof onClose === "function") {
      onClose();
    }
  };

  const modalContent = (
    <div className={`confirmation-modal-overlay${overlayClassName ? ` ${overlayClassName}` : ""}`}>
      <div className="confirmation-modal">
        <div className="confirmation-modal-header">
          <h2>{title}</h2>
          {!isNotification && ( // Only show close button if it's not just a notification
            <button className="details-close-button confirmation-close-button" onClick={onClose}>
              <i className="fi fi-rr-circle-xmark"></i>
            </button>
          )}
        </div>
        <div className="confirmation-modal-content">
          <p>{message}</p>
        </div>
        <div className="confirmation-modal-footer">
          {!isNotification && (
            <button
              className="action-button secondary-button" // Style similar to other cancel/secondary actions
              onClick={() => {
                if (typeof onCancel === "function") {
                  onCancel();
                } else if (typeof onClose === "function") {
                  onClose();
                }
              }}
            >
              {cancelText}
            </button>
          )}
          <button
            className={`action-button ${isPrimary ? 'primary-button' : ''} ${isDelete ? 'delete-confirm-button' : ''}`.trim()}
            onClick={handleConfirmClick}
          >
            {isNotification ? "OK" : confirmText}
          </button>
        </div>
      </div>
    </div>
  );

  return ReactDOM.createPortal(modalContent, document.body);
};

export default ConfirmationModal; 